import { Box, Container, Paper, Typography } from '@mui/material'
import bg from '../../assets/images/photo.png' // поставь свою картинку

export default function BusinessModel() {
  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Paper
          sx={{
            position: 'relative',
            overflow: 'hidden',
            p: { xs: 3, md: 5 },
            borderRadius: 5,
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff',
          }}
        >
          {/* 🔥 overlay затемнение */}
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(135deg, rgba(0,0,0,0.75), rgba(0,0,0,0.5))',
              zIndex: 1,
            }}
          />

          {/* 🔥 контент */}
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.6)' }}>
              Business model
            </Typography>

            <Typography variant="h3" sx={{ fontWeight: 700, mt: 1, mb: 2 }}>
              Risk-free partnership
            </Typography>

            <Typography
              sx={{
                color: 'rgba(255,255,255,0.8)',
                maxWidth: 760,
                lineHeight: 1.8,
                mb: 4,
              }}
            >
              We handle installation, maintenance, and operations. You simply provide
              the space and earn from every transaction.
            </Typography>

            {/* 🔥 ТВОЙ ПРОДАЮЩИЙ БЛОК */}
            <Box
              sx={{
                display: 'grid',
                gap: 1.5,
                mb: 5,
              }}
            >
              {[
                'Free installation',
                'Free service & maintenance',
                'No water connection required',
                'Only power outlet needed',
                'Small space required',
                '30-day risk-free trial',
              ].map((item) => (
                <Box
                  key={item}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      bgcolor: '#4caf50',
                    }}
                  />
                  <Typography sx={{ color: 'rgba(255,255,255,0.9)' }}>
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* 🔥 варианты */}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: 3,
              }}
            >
              <Paper
                sx={{
                  p: 3,
                  borderRadius: 4,
                  background: 'rgba(10,10,10,0.5)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff',
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                  Revenue Share
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.75)' }}>
                  Earn a percentage of all sales generated by the machine.
                </Typography>
              </Paper>

              <Paper
                sx={{
                  p: 3,
                  borderRadius: 4,
                  background: 'rgba(10,10,10,0.5)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff',
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                  Fixed Rent
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.75)' }}>
                  Receive a guaranteed monthly payment for hosting the machine.
                </Typography>
              </Paper>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}